import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { userAdminApi } from '@/api/client';
import type { JobsListResponse, JobRunsListResponse, JobRunDto, JobSlug } from '@/api/types';

const JOBS_QUERY_KEY = ['jobs'] as const;
const DEFAULT_RUNS_LIMIT = 30;

/** Resumen de los 2 jobs de sync AD — refresca cada 30s mientras el tab de Jobs esté montado. */
export function useJobsQuery() {
  return useQuery<JobsListResponse>({
    queryKey: JOBS_QUERY_KEY,
    queryFn: () => userAdminApi.getJobs(),
    refetchInterval: 30_000,
  });
}

/** Historial de corridas de un job — solo se activa cuando el usuario expande el historial
 * (options.enabled), para no pedir los 2 historiales de entrada al montar el tab. */
export function useJobRunsQuery(jobName: JobSlug, options: { enabled: boolean; limit?: number }) {
  const limit = options.limit ?? DEFAULT_RUNS_LIMIT;
  return useQuery<JobRunsListResponse>({
    queryKey: ['job-runs', jobName, limit],
    queryFn: () => userAdminApi.getJobRuns(jobName, limit),
    enabled: options.enabled,
  });
}

export function useTriggerJobMutation() {
  const queryClient = useQueryClient();
  return useMutation<JobRunDto, Error, JobSlug>({
    mutationFn: (jobName) => userAdminApi.triggerJob(jobName),
    onSettled: () => {
      void queryClient.invalidateQueries({ queryKey: JOBS_QUERY_KEY });
    },
  });
}
